import { EditableComponent } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';

// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
export { WishlistMostLovedProperties } from './WishlistMostLovedProperties';

const WishlistMostLovedPropertiesComp = dynamic(() =>
  import('./WishlistMostLovedProperties').then(mod => mod.WishlistMostLovedProperties)
);

export const WishlistMostLovedPropertiesConfig = {
  emptyLabel: 'wishlistmostlovedproperties',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/wishlistmostlovedproperties`,
};
/* eslint-disable @typescript-eslint/no-explicit-any */
export const WishlistMostLovedPropertiesEditable = (props: any) => (
  <EditableComponent config={WishlistMostLovedPropertiesConfig} {...props}>
    <WishlistMostLovedPropertiesComp {...props} />
  </EditableComponent>
);
